import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ROLE_PERMISSIONS = {
  "/dashboard": ["admin", "fleet_manager", "dealer"],
  "/fleet":     ["admin", "fleet_manager", "dealer", "service_engineer"],
  "/engine":    ["admin", "fleet_manager"],
  "/fuel":      ["admin", "fleet_manager"],
  "/geo":       ["admin", "fleet_manager"],
  "/service":   ["admin", "fleet_manager", "dealer", "service_engineer"],
  "/sales":     ["admin", "dealer"],
  "/dumper":    ["admin", "fleet_manager"],
  "/ai":        ["admin", "fleet_manager", "dealer", "service_engineer"],
  "/import":    ["admin"],
  "/reports":   ["admin", "fleet_manager", "dealer", "service_engineer"],
  "/settings":  ["admin", "fleet_manager", "dealer", "service_engineer"],
};

// Default landing route per role — picked from the first item the role is allowed to see.
const ROLE_LANDING = {
  admin: "/dashboard",
  fleet_manager: "/dashboard",
  dealer: "/dashboard",
  service_engineer: "/fleet",
};

export default function ProtectedRoute({ children }) {
  const { user, accessToken } = useAuth();
  const location = useLocation();

  if (!accessToken || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Path-level role check (prefix match for nested routes)
  const path = location.pathname.split("/").slice(0, 2).join("/");
  const allowed = ROLE_PERMISSIONS[path];
  if (allowed && !allowed.includes(user.role)) {
    const landing = ROLE_LANDING[user.role] || "/fleet";
    // Avoid an infinite redirect loop if landing == path (shouldn't happen given ROLE_LANDING values)
    if (landing !== path) {
      return <Navigate to={landing} replace />;
    }
  }

  return children;
}

export { ROLE_PERMISSIONS, ROLE_LANDING };
